import React , { useState } from 'react';
import './Navbar.css';
import './Navbar-a.css';

function Navbar() {

    const [header,setNavbar] = useState(false);

    const changeHeaderBG = () => {
        if (window.scrollY >= 80){
            setNavbar(true);
        }else{
            setNavbar(false);
        }
    }

   

    window.addEventListener('scroll',changeHeaderBG);

    return (
        <div className={ header ? 'header-a' : 'header' }>

            <div className={ header ? 'navbar-identity-container-a' : 'navbar-identity-container' }>

                <div className={ header ? 'navbar-identity-a' : 'navbar-identity' }>

                        <img src="files/logo/webco-logo-white.png" alt="" className={ header ? 'header-logo-a' : 'header-logo' } />

                        <h6 className={ header ? 'header-title-a' : 'header-title' }>Webco</h6>

                </div>

            </div>
            
            <div className={ header ? 'identity-navbar-divider-a' : 'identity-navbar-divider' } />
            
            <nav className={ header ? 'navbar-a' : 'navbar' }>

                <div >

                    <ul className={ header ? 'ul-a' : 'ul' }>

                        {/* <li className={ header ? 'li-a' : 'li' } ><a className={ header ? 'li_a' : ' li ' } href="">نمونه کار</a></li> */}
                        {/* <li className={ header ? 'li-a' : 'li' } ><a className={ header ? 'li_a' : ' li ' } href="">درباره ما</a></li> */}
                        {/* <li className={ header ? 'li-a' : 'li' } ><a className={ header ? 'li_a' : ' li ' } href="">▽  خدمات</a></li> */}
                        <li className={ header ? 'li-a' : 'li' } ><a className={ header ? 'li_a' : ' li ' } href="#contact-us">ارتباط با ما</a></li>
                        <li className={ header ? 'li-a' : 'li' } ><a className={ header ? 'li_a' : ' li ' } href="">صفخه اصلی</a></li>
                      </ul>

                </div>

            </nav>

            <div className={ header ? 'navbar-main-divider-a' : 'navbar-main-divider' } />

        </div>
    )
}

export default Navbar



// WEBPACK FOOTER //
// ./src/components/default/Navbar/Navbar.js